import React from "react";
import S from "./UserList.styled";
import User from "../User/User";
const UserItem = ({ user, handleToggle, selected }) => {
    return (React.createElement(S.UserLine, { onClick: () => handleToggle(!selected) },
        React.createElement(User, { user: user }),
        React.createElement(S.UserCheckbox, { type: "checkbox", checked: selected, id: `user-${user.id}`, readOnly: true })));
};
export default UserItem;
//# sourceMappingURL=UserItem.js.map